/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Trust_Coverage_DescInputs */

const en_home_trust_coverage_desc = /** @type {(inputs: Home_Trust_Coverage_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Protected wherever you travel`)
};

const fr_home_trust_coverage_desc = /** @type {(inputs: Home_Trust_Coverage_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Protégé où que vous voyagiez`)
};

/**
* | output |
* | --- |
* | "Protected wherever you travel" |
*
* @param {Home_Trust_Coverage_DescInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const home_trust_coverage_desc = /** @type {((inputs?: Home_Trust_Coverage_DescInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Trust_Coverage_DescInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_home_trust_coverage_desc(inputs)
	return fr_home_trust_coverage_desc(inputs)
});